import { NumberWithDecimalField } from './NumberWithDecimalField'
import { withNumberWithDecimalField } from './withNumberWithDecimalField'

const ConnectedNumberWithDecimalField = withNumberWithDecimalField(
  NumberWithDecimalField
)

export { ConnectedNumberWithDecimalField as NumberWithDecimalField }
